import "./DaIcon.css";
import PropTypes from "prop-types";

const ICON_MAP = {
  mail: "/ciam/v1/static/images/da/mail.svg",
  lock_open: "/ciam/v1/static/images/da/lock_open.svg",
  lock: "/ciam/v1/static/images/da/lock.svg",
  access_denied: "/ciam/v1/static/images/da/access_denied.svg",
};

const DEFAULT_ALT_MAP = {
  mail: "Mail icon",
  lock_open: "Open lock icon",
  lock: "Lock icon",
  access_denied: "Access denied icon",
};

const DaIcon = ({ type = "mail", alt }) => {
  const src = ICON_MAP[type] || ICON_MAP.mail;
  // Allow alt="" to mark the icon as decorative; fall back to the map then a generic label.
  const altText = alt !== undefined ? alt : DEFAULT_ALT_MAP[type] ?? "Icon";
  const imgClass = `da-${type.replace(/[^a-z0-9]+/gi, "-")}-icon-img`;

  return (
    <span className="da-icon-square">
      <img src={src} alt={altText} className={`${imgClass} da-icon-img`} />
    </span>
  );
};

DaIcon.propTypes = {
  type: PropTypes.string,
  alt: PropTypes.string,
};

export { DaIcon };
